import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=265a8900"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&id=265a8900&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports